import useNewHomepageEnabled from '../../common/use-new-homepage-enabled';
import { UserHomepage } from './custom-homepage';
import OldHome from './old';

const Home = () => {
  const newHomepageEnabled = useNewHomepageEnabled();
  if (!newHomepageEnabled) {
    return <OldHome />;
  }
  return <UserHomepage />;
};

export default Home;
